export default {
  title: {
    en: 'Oops!',
  },
  text: {
    en: `That product is temporarily out stock. All limited edition items are subject to availability. 
    If this item isn't available at the time of your next billing, we will automatically move it 
    to the next month in the queue and send you the next product you have scheduled instead.`,
  },
  cantMove: {
    title: {
      en: 'Sorry!',
    },
    text: {
      en: 'While this Product is temporary out of stock, it is impossible to put it forward in the queue.',
    },
  },
  button: {
    en: 'Got it',
  },
}
